'use client';

import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@shared/components/shadcn';
import { useTranslations } from 'next-intl';
import type { SkipConfirmationDialogProps } from './types';

function SkipConfirmationDialog({ isOpen, onConfirm, onCancel, dataTrackFeature, dataTrackContainer = 'Confirmation' }: SkipConfirmationDialogProps) {
  const actions = useTranslations('register.actions');

  const handlePreventDefault = (e: Event) => {
    e.preventDefault();
  };

  return (
    <Dialog open={isOpen} onOpenChange={open => !open && onCancel()}>
      <DialogContent
        className="z-[1001]"
        customOverlayClassName="z-[1001]"
        variant="dialog"
        onPointerDownOutside={handlePreventDefault}
        onEscapeKeyDown={handlePreventDefault}
        data-track-feature={dataTrackFeature}
        data-track-container={dataTrackContainer}
      >
        <DialogHeader>
          <DialogTitle>{actions('skipDialogTitle')}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{actions('skipDialogDescription')}</DialogDescription>
        <DialogFooter data-track-container="Actions">
          <Button variant="secondary" onClick={onCancel} data-track-name="Cancel">
            {actions('cancelSkip')}
          </Button>
          <Button onClick={onConfirm} data-track-name="Confirm">
            {actions('confirmSkip')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export { SkipConfirmationDialog };
